import { useMemo } from 'react';

import { breadcrumbsHome } from '@/productDiscovery/ProductPage/common/components/Breadcrumbs/translations';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';

export const useBreadcrumbs = (): {
  levels: { content: string; href: string; id: number }[];
} => {
  const { breadcrumbs, title } = useDetail();

  const levels = useMemo(
    () =>
      breadcrumbs?.length
        ? [
            { id: -1, content: breadcrumbsHome, href: '/' },
            ...breadcrumbs.map((crumb) => ({
              id: crumb.id,
              content: crumb.name,
              href: crumb.url || '',
            })),
            { id: 0, content: title || '', href: '' },
          ]
        : [],
    [breadcrumbs, title],
  );

  return { levels };
};
